import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { Edition } from "@/types/edition";

export const useContentStore = defineStore("content", () => {
  const selectedEdition = ref<Edition | undefined>();
  const downloadSelectedEdition = ref<Edition | undefined>();
  const showSearchModal = ref(false);
  const selectedEditionPage = ref<number | undefined>();

  const showEditionModal = computed<boolean>({
    get: () => !!selectedEdition.value,
    set: (value: boolean) => {
      if (!value) {
        selectedEdition.value = undefined;
        selectedEditionPage.value = undefined;
      }
    },
  });

  const showDownloadModal = computed({
    get: () => !!downloadSelectedEdition.value,
    set: (value: boolean) => {
      if (!value) {
        downloadSelectedEdition.value = undefined;
      }
    },
  });

  const closeModals = () => {
    showEditionModal.value = false;
    showDownloadModal.value = false;
  };

  return {
    selectedEdition,
    downloadSelectedEdition,
    showSearchModal,
    showEditionModal,
    showDownloadModal,
    selectedEditionPage,
    closeModals,
  };
});
